export default "__VITE_ASSET__DJumMDwJ__"